import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-security-policies',
  templateUrl: './security-policies.component.html',
  styleUrls: ['./security-policies.component.scss']
})
export class SecurityPoliciesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
